import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Input,
  Label,
  FormFeedback,
  Modal,
  Button,
} from "reactstrap"

import Select from "react-select"

// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"

import { Link, useHistory, useParams, useLocation } from "react-router-dom"

// import images
import logo from "assets/images/logo-large.png"

import "../../../assets/scss/custom/style.css"

import Autocomplete from "@material-ui/lab/Autocomplete"
import Box from "@material-ui/core/Box"
import { TextField } from "@material-ui/core"
import Snackbars from "../../../Utils/Snackbars"
import useRequestsWOAccessToken from "../../../Utils/useRequestsWOAccessToken"
import i18next from "i18next"

const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: "#ffffff",
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? "#036B41"
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? "#fff"
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ":active": {
      ...styles[":active"],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}

const AddPhone = props => {
  //meta title
  document.title = i18next.t("Register PG document title")
  const history = useHistory()
  const { getRequestWOAccessToken, postRequestWOAccessToken } =
    useRequestsWOAccessToken()
  const location = useLocation()

  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  })
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "",
        message: "",
      }))
    }, 5000)
  }

  const [formData1, setFormData1] = React.useState({
    country: { label: "Spain", value: "Spain" },
    country_code: { id: 212, title: "ES +34", code: "ES", value: 34 },
  })
  const [CustomError1, setCustomError1] = React.useState({
    country: "",
    country_code: "",
  })
  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      phone: "",
    },
    validationSchema: Yup.object({
      phone: Yup.string()
        .matches(/^[#0-9]+$/, i18next.t("Please enter a valid value!"))
        .required(i18next.t("Register PG Mobile Number is required"))
        .test(
          "len",
          i18next.t(
            "Register PG Mobile numbers should be 9 digits long for Spain and 10 digits long for other countries!",
          ),
          function (value) {
            const country_code = parseInt(formData1.country_code.value)
            const length = value ? value.length : 0
            if (country_code === 34 || country_code === 32 || country_code === 33) {
              return length === 9 // For country code 34 and 32, phone number should be exactly 9 digits
            }
            else if (country_code === 370) {
              return length === 8 // For country code 370, phone number should be exactly 8 digits
            } else {
              return length === 10 // For other country codes, phone number should be exactly 10 digits
            }
          },
        ),
    }),
    onSubmit: async values => {
      try {
        setCustomError1({
          ...CustomError1,
          country_code: "",
        })

        if (formData1.country_code === null) {
          setCustomError1({
            ...CustomError1,
            country_code: i18next.t("Register PG Please select country code"),
          })
        } else {
          let submit1 = document.getElementById("submit1")
          submit1.disabled = true
          submit1.textContent = i18next.t("Processing...")

          const jsonpar = JSON.stringify({
            u_id: UID,
            country_code: formData1.country_code.value,
            phone: values.phone,
          })
          const res = await postRequestWOAccessToken("update-phone", jsonpar)
          if (res && res.code === 200) {
            let originalText = res.data

            history.push("/phone-verification", {
              id: UID,
              email: Email,
              country_code: formData1.country_code.value,
              phone: values.phone,
              collaborator_referral_code: collaboratorReferralCode,
              referral_code: referralCode,
              code: 200,
              status: "success",
              message: res.message,
            })
          } else {
            setAlertData(AlertData => ({
              ...AlertData,
              variant: "error",
              message: res.message,
            }))
          }
          resetAlertData()

          submit1.disabled = false
          submit1.textContent = i18next.t("Continue")
        }
      } catch (error) {
        console.error("Error : ", error)
      }
    },
  })

  const [AllCountriesCustomData, setAllCountriesCustomData] = React.useState([])
  const [AllCountriesCustomData2, setAllCountriesCustomData2] = React.useState(
    [],
  )
  const handleLoadGetAllCountries = async () => {
    const res = await getRequestWOAccessToken("get-all-countries")
    if (res && res.code === 200) {
      let originalText = res.data

      let tempArr = []
      originalText.forEach(element => {
        let temp = {
          label: element.country_name,
          value: element.country_name,
        }
        tempArr.push(temp)
      })
      tempArr = [
        {
          options: tempArr,
        },
      ]
      setAllCountriesCustomData2(tempArr)

      tempArr = []
      originalText.forEach(element => {
        let temp = {
          id: element.id,
          title: element.country_code + " +" + element.phone_code,
          code: element.country_code,
          value: element.phone_code,
        }
        tempArr.push(temp)
      })
      setAllCountriesCustomData(tempArr)
    } else {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "error",
        message: res.message,
      }))
    }
    resetAlertData()
  }
  const [PreferredLanguage, setPreferredLanguage] = React.useState("eng")
  const onChangePreferredLanguage = e => {
    i18next.changeLanguage(e.target.value)
    setPreferredLanguage(e.target.value)
    localStorage.setItem("I18N_LANGUAGE", e.target.value)
  }

  const handleLoadGetSignupStatus = async u_id => {
    const jsonpar = JSON.stringify({
      u_id: u_id,
    })

    const res = await postRequestWOAccessToken("signup-status", jsonpar)
    if (res && res.code === 200) {
      let originalText = res.data
      if (originalText.is_email_verified == 0) {
        history.push("/email-verification", {
          id: u_id,
          email: originalText.email,
          collaborator_referral_code:
            originalText.signup_temp_collaborator_code,
          referral_code: originalText.signup_temp_referral_code,
        })
      } else if (
        originalText.phone == "" ||
        originalText.phone == null ||
        originalText.phone == undefined
      ) {
        return
      } else if (originalText.is_phone_verified == 0) {
        history.push("/phone-verification", {
          id: u_id,
          email: originalText.email,
          country_code: originalText.country_code,
          phone: originalText.phone,
          collaborator_referral_code:
            originalText.signup_temp_collaborator_code,
          referral_code: originalText.signup_temp_referral_code,
        })
      } else if (
        originalText.first_name == null ||
        originalText.first_name == "" ||
        originalText.last_name == null ||
        originalText.last_name == ""
      ) {
        history.push("/personal-details", {
          id: u_id,
          email: originalText.email,
          country_code: originalText.country_code,
          phone: originalText.phone,
          collaborator_referral_code:
            originalText.signup_temp_collaborator_code,
          referral_code: originalText.signup_temp_referral_code,
        })
      } else if (originalText.address == null || originalText.address == "") {
        history.push("/address", {
          id: u_id,
          email: originalText.email,
          country_code: originalText.country_code,
          phone: originalText.phone,
          country: originalText.country,
          collaborator_referral_code:
            originalText.signup_temp_collaborator_code,
          referral_code: originalText.signup_temp_referral_code,
        })
      } else if (originalText.tax_id == null || originalText.tax_id == "") {
        history.push("/tax", {
          id: u_id,
          email: originalText.email,
          country_code: originalText.country_code,
          phone: originalText.phone,
          country: originalText.country,
          collaborator_referral_code:
            originalText.signup_temp_collaborator_code,
          referral_code: originalText.signup_temp_referral_code,
        })
      } else if (originalText.accept_terms == "false") {
        history.push("/terms", {
          id: u_id,
          email: originalText.email,
          country_code: originalText.country_code,
          phone: originalText.phone,
          collaborator_referral_code:
            originalText.signup_temp_collaborator_code,
          referral_code: originalText.signup_temp_referral_code,
        })
      } else {
        history.push("/login")
      }
    } else {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "error",
        message: res.message,
      }))
    }
  }

  const [UID, setUID] = React.useState(0)
  const [Email, setEmail] = React.useState("")
  const [collaboratorReferralCode, SetCollaboratorReferralCode] =
    React.useState("")
  const [referralCode, SetReferralCode] = React.useState("")
  React.useEffect(() => {
    const language = localStorage.getItem("I18N_LANGUAGE")
    if (!language) {
      setPreferredLanguage("sp")
    } else {
      setPreferredLanguage(language)
    }

    handleLoadGetAllCountries()

    if (
      typeof location.state !== "undefined"
    ) {
      handleLoadGetSignupStatus(location.state.id)
      setUID(location.state.id)
      setEmail(location.state.email)
      SetCollaboratorReferralCode(location.state.collaborator_referral_code)
      SetReferralCode(location.state.referral_code)
      if(location.state.message){
        setAlertData(AlertData => ({
          ...AlertData,
          variant: location.state.status,
          message: location.state.message,
        }))
        resetAlertData()
      }
    }
  }, [])

  return (
    <React.Fragment>
      {AlertData.message !== "" ? (
        <Snackbars variant={AlertData.variant} message={AlertData.message} />
      ) : (
        ""
      )}
      <div className="p-0 container-fluid">
        {/* <select
          className="form-select top-right-lang"
          name="preferred_language"
          value={PreferredLanguage}
          onChange={e => onChangePreferredLanguage(e)}
        >
          <option value={"eng"}>English</option>
          <option value={"sp"}>Spanish</option>
        </select> */}
        <Row className="g-0">
          <Col className="LeftImg">
            <div className="auth-full-page-content p-3 bg-white">
              <div className="w-100">
                <div className="d-flex flex-column h-100">
                  <div className="mb-4 mb-md-5">
                    <Link to="/" className="auth-logo-light">
                      <div className="mb-1">
                        <span className="">
                          {" "}
                          <img src={logo} alt="" height="60" />{" "}
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="my-auto">
                    <div className="text-primary p-4">
                      <h2 className="text-black mb-3">
                        {i18next.t("Phone Number")}
                      </h2>
                      <p className="text-black" style={{ fontSize: '17px' }}>
                        {i18next.t("We are going  to send you a SMS with your verification code")}
                      </p>
                    </div>
                    <div className="mt-4">
                      <div className="p-2">
                        <div className="form-horizontal">
                          <div className="row">
                            <Col md={5}>
                              <div className="mb-3 Register-Select-Code fullWidth">
                                <Label>
                                  {i18next.t("Profile PG Select country code")} :
                                </Label>
                                <Autocomplete
                                  sx={{ width: "100%" }}
                                  value={formData1.country_code}
                                  onChange={(event, newValue) => {
                                    setFormData1({
                                      ...formData1,
                                      country_code: newValue,
                                    })
                                  }}
                                  id="country-code"
                                  options={AllCountriesCustomData}
                                  getOptionLabel={option => option.title}
                                  renderOption={option => (
                                    <Box
                                      component="li"
                                      sx={{
                                        "& > img": { mr: 2, flexShrink: 0 },
                                      }}
                                    >
                                      <img
                                        loading="lazy"
                                        width="20"
                                        src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                                        srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                                        alt={option.code}
                                      />
                                      &nbsp;{option.title}
                                    </Box>
                                  )}
                                  renderInput={params => (
                                    <TextField {...params} variant="outlined" />
                                  )}
                                />
                                {CustomError1.country_code !== "" ? (
                                  <FormFeedback
                                    type="invalid"
                                    style={{ display: "block" }}
                                  >
                                    {CustomError1.country_code}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>

                            <Col md={7}>
                              <div className="mb-3">
                                <Label>{i18next.t("Phone Number")} :</Label>
                                <Input
                                  name="phone"
                                  type="number"
                                  placeholder={i18next.t("Enter Phone Number")}
                                  onChange={validation1.handleChange}
                                  onBlur={validation1.handleBlur}
                                  value={validation1.values.phone || ""}
                                  invalid={
                                    validation1.touched.phone &&
                                    validation1.errors.phone
                                      ? true
                                      : false
                                  }
                                />
                                {validation1.touched.phone &&
                                validation1.errors.phone ? (
                                  <FormFeedback type="invalid">
                                    {validation1.errors.phone}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                          </div>

                          <div className="mt-4 d-grid">
                            <Button
                              id="submit1"
                              onClick={e => {
                                e.preventDefault()
                                validation1.handleSubmit()
                                return false
                              }}
                              className="btn btn-primary btn-block"
                            >
                              {i18next.t("Continue")}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-4 mt-md-5 text-center">
                    <p className="footer-text-color">
                      {" "}
                      © {new Date().getFullYear()} Tokenizedgreen.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col className="rightImg">
            <div className="bgLogin"></div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}

export default AddPhone
